export default "__VITE_ASSET__93f2c5b8__"